import { render, staticRenderFns } from "./edit-base.vue?vue&type=template&id=17fb97df&"
import script from "./edit-base.vue?vue&type=script&lang=ts&"
export * from "./edit-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports